import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataSuspension } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeSuspensionAccordionProps {
  suspensionData?: EquipmentModelLatestFipeDataSuspension
}

export default function FipeSuspensionAccordion({ suspensionData }: FipeSuspensionAccordionProps) {
  return (
    <Accordion
      name="Suspension"
      head="Suspensão"
      defaultOpen
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Dianteira" 
            value={suspensionData?.Dianteira} 
          />
          <InfoField 
            label="Traseira" 
            value={suspensionData?.Traseira} 
          />
          <InfoField 
            label="Elemento Elástico" 
            value={suspensionData?.["Elemento Elastico"]} 
          />
        </div>
      }
    />
  )
}